import React from "react";
import { createStyles } from "@mantine/emotion";

const useStyles = createStyles((theme) => ({
  applayout: {
    height: "100vh",
    // overflowY: "scroll",
    display: "flex",
    flexDirection: "column",
    // "& ::-webkit-scrollbar": {
    //   width: "10px",
    // },
    // "& ::-webkit-scrollbar-track": {
    //   "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.3)",
    // },
    // "& ::-webkit-scrollbar-thumb": {
    //   backgroundColor: theme.app.scrollbar,
    //   outline: `1px solid ${theme.app.borderColor}`,
    // },
    "@media print": {
      width: "100%",
      height: "auto",
      "& ::-webkit-scrollbar": {
        display: "none",
      },
    },
  },
}));

const AppLayout = ({ pageName, children }) => {
  const { classes } = useStyles();
  return (
    <div className={classes.applayout + " page-" + pageName}>{children}</div>
  );
};

export default AppLayout;
